import type { ReactNode } from 'react';

import '@/components/shared/circonstance-card.css';

export interface CirconstanceCardProps {
    children?: ReactNode;
}

const CirconstanceCard = ({ children }: CirconstanceCardProps) => {
    return (
        <div className={`card-circ`}>
            <div className={'card-header'}>{children}</div>
        </div>
    );
};

export default CirconstanceCard;
